import { Fragment, useEffect, useState } from 'react';
import aiPlay from '../../assets/images/airplay.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import GrayledDropdown from '../GrayledDropdown';

export const Sidebar = ({
  sideBarEvent,
  userType = 'student',
  // setGotoSubject,
}) => {
  const mode = localStorage.getItem('mode');
  const navigate = useNavigate();
  const [lastBookId, setLastBookId] = useState(null);
  useEffect(() => {
    const storedBookId = localStorage.getItem('lastBookId');
    if (storedBookId) {
      setLastBookId(storedBookId);
    }
  }, []);

  const getBackLink = () => {
    if (mode === 'assigned-mode') {
      return `/assign/${lastBookId}`;
    } else if (mode === 'create-mode') {
      return lastBookId ? `/create/${lastBookId}` : '/createbook';
    } else {
      return '/dashboard'; // fallback route
    }
  };

  return (
    <Fragment>
      {/* <!-- Sidebar Holder --> */}
      <nav
        id='sidebar'
        className={userType === 'teacher' ? 'prof' : ''}
        style={{
          boxShadow: userType === 'teacher' ? '0px 0px 12px 0px rgba(0, 0, 0, 0.08)' : '',
        }}
      >
        <div className='top-list'>
          <div className='sidebar-header'>
            {' '}
            <GrayledDropdown mode='teach' />
          </div>
          <ul className='unlist-styleds '>
            <li
              className={`${sideBarEvent === 'overview' ? ' overview_style active' : ' overview_style'} prof cursor`}
              onClick={(e) => {
                navigate('/dashboard');
              }}
            >
              <a>
                {' '}
                <span className='icon-svg'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='grid'>
                      <path id='Vector' d='M10 3H3V10H10V3Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_2' d='M21 3H14V10H21V3Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_3' d='M21 14H14V21H21V14Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_4' d='M10 14H3V21H10V14Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                  </svg>
                </span>{' '}
                overview{' '}
              </a>
            </li>
            <li
              className={`cursor prof ${sideBarEvent === 'classes' ? 'active' : ''}`}
              onClick={(e) => {
                navigate('/dashboard/classes', { replace: true });
              }}
            >
              <a>
                {' '}
                <span className='icon-svg'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='book-open'>
                      <path id='Vector' d='M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_2' d='M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                  </svg>
                </span>{' '}
                classes{' '}
              </a>
            </li>
            <li
              className={`cursor prof ${sideBarEvent === 'activities' ? 'active' : ''}`}
              onClick={(e) => {
                navigate('/dashboard/activities');
              }}
            >
              <a>
                {' '}
                <span className='icon-svg'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='file-text'>
                      <path id='Vector' d='M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_2' d='M14 2V8H20' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_3' d='M16 13H8' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_4' d='M16 17H8' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_5' d='M10 9H9H8' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                  </svg>
                </span>{' '}
                activities{' '}
              </a>
            </li>
            <li className='li_disable_tab'>
              <a style={{ color: '#BAB5B0' }}>
                {' '}
                <span className='icon-svg'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path d='M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z' stroke='gray' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                </span>{' '}
                messaging{' '}
              </a>
            </li>
            <li className='cursor prof'>
              <Link style={{ textDecoration: 'none' }} to={getBackLink()}>
                <svg style={{ marginRight: '12px' }} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M19 12H5' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                  <path d='M12 19L5 12L12 5' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
                back to book
              </Link>
            </li>
          </ul>
        </div>
        {userType === 'teacher' && (
          <div className=''>
            <ul className='unlist-styleds '>
              <li className='li_disable_tab'>
                <a style={{ color: '#BAB5B0' }}>
                  {' '}
                  <span className='icon-svg'>
                    <img src={aiPlay} alt='screen' />
                  </span>{' '}
                  Present{' '}
                </a>
              </li>

              <li className='cursor prof'>
                <Link to={lastBookId ? `/create/${lastBookId}` : '/createbook'} className='text-decoration-none'>
                  <span className='icon-svg'>
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M12 19L19 12L22 15L15 22L12 19Z' stroke='#2e2e2d' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z' stroke='#2e2e2d' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M2 2L9.586 9.586' stroke='#2e2e2d' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z' stroke='#2e2e2d' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                  </span>{' '}
                  create{' '}
                </Link>
              </li>
              <li className={`cursor prof ${sideBarEvent === 'bookshelf' || sideBarEvent === 'bookshelf/overview' ? 'active' : ''}`}>
                <Link className='text-decoration-none' to='/dashboard/bookshelf'>
                  <span className='icon-svg'>
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path d='M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                  </span>{' '}
                  My bookshelf
                </Link>
              </li>
            </ul>
          </div>
        )}
        <div className='bottom-list'>
          <ul className='list-unstyled  '>
            <li>
              <a>
                {' '}
                <span className='icon-svg'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='help-circle'>
                      <path id='Vector' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_2' d='M9.08984 9.00057C9.32495 8.33224 9.789 7.76868 10.3998 7.4097C11.0106 7.05073 11.7287 6.91951 12.427 7.03928C13.1253 7.15906 13.7587 7.52209 14.2149 8.0641C14.6712 8.6061 14.9209 9.29209 14.9198 10.0006C14.9198 12.0006 11.9198 13.0006 11.9198 13.0006' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path id='Vector_3' d='M12 17H12.01' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                    </g>
                  </svg>
                </span>{' '}
                support{' '}
              </a>
            </li>
            <li
              className={`cursor prof ${sideBarEvent === 'profile' ? 'active' : ''}`}
              onClick={(e) => {
                navigate('/dashboard/settings');
              }}
            >
              <a>
                {' '}
                <span className='icon-svg'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='settings' clipPath='url(#clip0_1379_11116)'>
                      <path id='Vector' d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' stroke='#2E2E2D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                      <path
                        id='Vector_2'
                        d='M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z'
                        stroke='#2E2E2D'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_1379_11116'>
                        <rect width='24' height='24' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </span>{' '}
                settings{' '}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </Fragment>
  );
};
export default Sidebar;
